import { createRoot, Root } from 'react-dom/client';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { createTheme, ThemeProvider } from '@mui/material';
import { ConfirmDeleteModal } from '../../../apps/legacy-app/src/components/common/ConfirmDeleteModal';
import i18n from 'i18next';
import { Resource } from '../resources';

interface ConfirmationOptions {
  title?: string;
  message?: string;
  confirmButtonKey?: string;
  cancelButtonKey?: string;
  resource?: Resource | Resource[];
}

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#ff7c43',
      contrastText: '#fff',
    },
    secondary: {
      main: '#8a9aae',
      contrastText: '#fff',
    },
    background: {
      default: '#f5f6fa',
    },
  },
});

class ConfirmationService {
  private root: Root | null = null;
  private container: HTMLElement | null = null;

  private createModalContainer(): void {
    if (this.container) return;

    this.container = document.createElement('div');
    document.body.appendChild(this.container);
    this.root = createRoot(this.container);
  }

  private cleanup(): void {
    if (this.root && this.container) {
      this.root.unmount();
      document.body.removeChild(this.container);
      this.root = null;
      this.container = null;
    }
  }

  async confirmDelete(options: ConfirmationOptions = {}): Promise<boolean> {
    return new Promise((resolve) => {
      this.createModalContainer();

      const handleConfirm = () => {
        this.cleanup();
        resolve(true);
      };

      const handleCancel = () => {
        this.cleanup();
        resolve(false);
      };

      const ConfirmModal = React.createElement(
        ThemeProvider,
        { theme: defaultTheme },
        React.createElement(
          I18nextProvider,
          { i18n },
          React.createElement(ConfirmDeleteModal, {
            open: true,
            onConfirm: handleConfirm,
            onCancel: handleCancel,
            title: options.title,
            message: options.message,
            confirmButtonKey: options.confirmButtonKey,
            cancelButtonKey: options.cancelButtonKey,
            resource: options.resource,
          } as React.ComponentProps<typeof ConfirmDeleteModal>)
        )
      );

      this.root!.render(ConfirmModal);
    });
  }
}

export const confirmationService = new ConfirmationService();
